module.exports = __webpack_public_path__ + "img/miriam.28412473.png";